export default __webpack_public_path__ + "static/media/shopcart.6cb4f1bf.svg";